import React, { memo } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { formatGuardianApiDate } from '../../utils/date';

import type { PlayerKitClub } from './types';

const strings = STRINGS.guardianPlayer.kitNotes;

type KitClubsCardProps = {
  clubs: readonly PlayerKitClub[];
};

/** Single white card listing every kit provided, newest level first, per the design. */
function KitClubsCard({ clubs }: KitClubsCardProps) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Stack gap={scale(16)} style={styles.card}>
      <Text variant="Font Inter/Subtitle/Bold 11px" style={styles.title}>
        {strings.kitListTitle}
      </Text>
      {clubs.map((club, index) => (
        <Stack key={`${club.level}-${club.date}-${index}`} gap={scale(8)}>
          <Text variant="Font Inter/Subtitle/Regular" style={styles.line}>
            {strings.kitLevelLabel(club.level ?? 0)}
          </Text>
          <Text variant="Font Inter/Subtitle/Regular" style={styles.line}>
            {strings.kitProvidedLine(
              formatGuardianApiDate(club.date, 'MM/dd/yy'),
              club?.coachName ?? '',
            )}
          </Text>
        </Stack>
      ))}
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  card: {
    padding: scale(12),
    borderRadius: scale(12),
    backgroundColor: colors['0'],
  },
  title: {
    color: colors['Labels/Primary'],
  },
  line: {
    color: colors['Labels/Primary'],
  },
}));

export default memo(KitClubsCard);
